import { BoxV2Icon } from '@jouzen/ecom-components/icons/BoxV2Icon';
import { CalendarIcon } from '@jouzen/ecom-components/icons/CalendarIcon';
import { CareIcon } from '@jouzen/ecom-components/icons/CareIcon';
import { HsaFsaCheckLogo } from '@jouzen/ecom-components/icons/HsaFsaCheckLogo';
import { OuraSymbolIcon } from '@jouzen/ecom-components/icons/OuraSymbolIcon';
import { TelephoneIcon } from '@jouzen/ecom-components/icons/TelephoneIcon';
import type { MessageKey } from 'types/LocaleMessageKey';
import type { SVGIconComponent } from 'types/svgr';

export interface ReasonToBuy {
  title: MessageKey;
  description: MessageKey;
  Icon: SVGIconComponent;
  iconClassName?: string;
}

const reasonsToBuyData: ReasonToBuy[] = [
  {
    title: 'fast_shipping',
    description: 'fast_shipping_subcopy',
    Icon: BoxV2Icon,
    iconClassName: '-scale-x-100', // flip horizontally
  },
  {
    title: 'pay_with_hsa',
    description: 'pay_with_hsa_subcopy',
    Icon: HsaFsaCheckLogo,
  },
  {
    title: 'free_easy_returns',
    description: 'free_easy_returns_subcopy',
    Icon: CareIcon,
  },
  {
    title: 'free_trial_month',
    description: 'free_trial_month_subcopy',
    Icon: CalendarIcon,
  },
  {
    title: 'limited_one_year_warranty',
    description: 'limited_one_year_warranty_subcopy',
    Icon: OuraSymbolIcon,
  },
  {
    title: '24_7_support',
    description: '24_7_support_subcopy',
    Icon: TelephoneIcon,
  },
];

export default reasonsToBuyData;
